import { apiClient } from './client';

export interface AuthUser {
  id: number;
  username: string;
  email: string | null;
  phone: string | null;
  name: string;
  role: string;
}

export interface LoginResponse {
  token: string;
  token_type: 'Bearer';
  expires_at: string;
  user: AuthUser;
}

export async function platformAdminLogin(
  identifier: string,
  password: string,
): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>('/platform-admin/login', {
    identifier,
    password,
  });
  return data;
}

export async function logout(): Promise<void> {
  await apiClient.post('/platform-admin/logout');
}

export async function fetchCurrentUser(): Promise<AuthUser> {
  const { data } = await apiClient.get<AuthUser>('/platform-admin/me');
  return data;
}
